import Alert from '@mui/material/Alert';
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import RadioGroup from "@mui/material/RadioGroup";
import {
	globalStyles,
	noop,
	SUPPORTED_COUNTRIES,
} from "@client/shared/constants";
import TextField from "@mui/material/TextField";
import style from "./style";
import InputAdornment from "@mui/material/InputAdornment";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { Dropdown } from "@client/shared/components";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import Skeleton from '@mui/material/Skeleton';

const BulkEditView = ({
	areAllSelected = false,
	selectedRows = [],
	confirmEdit = true,
	countryList = [],
	onClose = noop,
	onPreferenceChange = noop,
	onSave = noop,
	open = true,
	confirming = false,
	updating = false,
	handleClose = noop,
	currentSection = 0,
	isSectionComplete = noop,
	triggerNotificationType = "NOTIFICATION_TRIGGER_TYPES.PHONE_NUMBER",
	NOTIFICATION_TRIGGER_TYPES,
	isParsingPhoneNumber = false,
	extensionNumber = "",
	phoneNumber = "",
	phoneNumberError = null,
	callDirection = "Outbound",
	handleFormSubmit = noop,
	handleCallDirection = noop,
	triggerNotificationOnChange = noop,
	phoneNumberOnChange = noop,
	phoneNumberOnBlur = noop,
	extensionNumberOnChange = noop,
	onClickBack = noop,
	onClickNext = noop,
	handlePhoneNumber = noop,
	onPhoneNumParsedSuccess = noop,
	hasPreferenceCheck = false,
	selectedCountry = {},
	handleCountrySelection = noop,
	handleParsePhoneNumber = noop,
	parsePhoneNumber = noop,
	handleKeyDown = noop,
	extensionList = [],
	handleVoicemailExtension = noop,
	voicemail_extensions = {},
	hasVoicemailExtensions = false,
	loadedExtension = false,
}) => {
	return (
		<>
			<Dialog
				classes={{
					paper: style.bulkEditPaper,
				}}
				open={open}
				onClose={handleClose}
			>
				<DialogTitle hasClose>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Typography variant="h6" sx={{ mt: 2 }}>
							Bulk Edit
						</Typography>
						<IconButton>
							<CloseIcon
								sx={{ color: "grey.600" }}
								fontSize="small"
								onClick={handleClose}
							/>
						</IconButton>
					</Box>
				</DialogTitle>
				<DialogContent sx={{ height: 480 }}>
					<Typography sx={{ color: "grey", mb: 5 }} variant="body1">
						Bulk edit multiple notifications at once by changing the phone
						number that triggers the notification and/or the direction that
						engages the trigger. This will overwrite exisitng settings for the
						notifications that you have selected to bulk edit.
					</Typography>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "flex-start",
						}}
					>
						<Typography sx={{ color: "#199afa" }} variant="h6">
							Notifications Selected:
						</Typography>
						<Typography sx={{ color: "#199afa", ml: 2 }} variant="h6">
							{areAllSelected ? "All" : selectedRows.length}
						</Typography>
					</Box>
					<Box>
						<Box
							// className={clsx(
							//   "m-4 d-flex f-justify-between f-align-center",
							//   classes.stepper
							// )}
							sx={{
								...style.stepper,
								m: 4,
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
							}}
						>
							<Box
								// className={clsx(
								//   "d-flex flex-column f-align-center f-justify-center",
								//   classes.step,
								//   {
								//     [classes.activeStep]: state.currentSection === 0,
								//     [classes.successStep]:
								//       state.currentSection !== 0 && isSectionComplete(0),
								//   }
								// )}
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									justifyContent: "center",
									...style.step,
									...(currentSection === 0 && style.activeStep),
									...(currentSection !== 0 &&
										isSectionComplete(0) &&
										style.successStep),
								}}
							>
								<img
									alt=""
									src={
										currentSection === 0
											? "/assets/phone.svg"
											: isSectionComplete(0)
											? "/assets/phone-green.svg"
											: "/assets/phone-default.svg"
									}
								/>
								<Typography sx={{ mt: 1 }} variant="caption">
									Phone Number
								</Typography>
							</Box>
							<Box
								// className={clsx(
								//   "d-flex flex-column f-align-center f-justify-center",
								//   classes.step,
								//   {
								//     [classes.activeStep]: state.currentSection === 1,
								//     [classes.successStep]:
								//       state.currentSection !== 1 && isSectionComplete(1),
								//   }
								// )}
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									justifyContent: "center",
									...style.step,
									...(currentSection === 1 && style.activeStep),

									...(currentSection !== 1 &&
										isSectionComplete(1) &&
										style.successStep),
								}}
							>
								<img
									alt=""
									src={
										currentSection === 1
											? "/assets/calldirection.svg"
											: isSectionComplete(1)
											? "/assets/calldirection-green.svg"
											: "assets/icons/calldirection-default.svg"
									}
								/>
								<Typography sx={{ mt: 1 }} variant="caption">
									Direction
								</Typography>
							</Box>
						</Box>
						<Box sx={{ marginBottom: "4px" }}>
							{currentSection === 0 && (
								<Box sx={style.formSectionWrapper}>
								{hasVoicemailExtensions && <Alert sx={{ my: 2 }} severity="warning">
                Notifications using voicemail extensions cannot be edited using bulk edit.
              </Alert>}
									<Typography sx={{ color: "grey", mb: 2 }} variant="h5">
										Number or Extension to Trigger Notification
									</Typography>
									<Typography
										// className="color-grey secondary-font mb-1"
										sx={{ color: "grey", mb: 1 }}
										variant="subtitle2"
									>
										{triggerNotificationType === "voicemail-notification"
											? "This is the voicemail box that will trigger the notification."
											: "This is the number or account extension that triggers the notification to be sent."}
									</Typography>
									<RadioGroup
										sx={{ display: "flex", flexDirection: "row" }}
										aria-label="Trigger Notification Type"
										name="trigger-notification-type"
										value={triggerNotificationType}
										onChange={(e) => {
											const notificationType = e.target?.value;
											triggerNotificationOnChange(e);
											handleCallDirection({
												currentTarget: {
													value: notificationType === "voicemail-notification" ? "Inbound" : "Outbound",
												},
											});
										}}
									>
										<FormControlLabel
											value={NOTIFICATION_TRIGGER_TYPES.PHONE_NUMBER}
											control={<Radio disabled={hasVoicemailExtensions} />}
											label={
												<Box
													sx={{
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}
												>
													<Typography sx={{ mr: 2 }} variant="body2">
														Phone number
													</Typography>
												</Box>
											}
										/>
										<FormControlLabel
											value={NOTIFICATION_TRIGGER_TYPES.EXTENSION}
											control={<Radio disabled={hasVoicemailExtensions} />}
											label={
												<Box
													sx={{
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}
												>
													<Typography sx={{ mr: 2 }} variant="body2">
														Extension
													</Typography>
												</Box>
											}
										/>
										<FormControlLabel
											value={NOTIFICATION_TRIGGER_TYPES.VOICEMAIL_NOTIFICATION}
											control={<Radio disabled={hasVoicemailExtensions} />}
											label={
												<Box
													sx={{
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}
												>
													<Typography
														sx={{ marginRight: "4px" }}
														variant="body2"
													>
														Voicemail Notification
													</Typography>
												</Box>
											}
										/>
									</RadioGroup>
									{triggerNotificationType ===
										NOTIFICATION_TRIGGER_TYPES.PHONE_NUMBER && (
										<TextField
											fullWidth
											size="small"
											disabled={isParsingPhoneNumber || hasVoicemailExtensions}
											label="Phone #"
											name="main_number"
											value={phoneNumber}
											sx={{ width: "350px", marginTop: "12px" }}
											// error={!!error}
											// helperText={error}
											onKeyDown={(event) => handleKeyDown(event)}
											InputProps={{
												startAdornment: (
													<InputAdornment position="start">
														<Box
															sx={{
																paddingRight: 1,
																borderRight: "1px solid gray",
																height: "24px",
															}}
														>
															<Dropdown
													disablePortal={false}
													disabled={hasVoicemailExtensions}
																customToggle={
																	<Box
																		sx={{
																			...globalStyles.display.flex,
																			...globalStyles.flex.align.center,
																			...globalStyles.cursor.pointer,
																			paddingTop: "2px",
																		}}
																	>
																		<Typography
																			variant="body2"
																			color="common.black"
																		>
																			{selectedCountry.isoCode}
																		</Typography>
																		<KeyboardArrowDown />
																	</Box>
																}
																classes={{
																	menu: { maxHeight: 320, maxWidth: 220 },
																}}
																options={[
																	...SUPPORTED_COUNTRIES,
																	...countryList.filter(
																		(country) =>
																			SUPPORTED_COUNTRIES.findIndex(
																				(supportedCountry) =>
																					supportedCountry.isoCode ===
																					country.isoCode
																			) === -1
																	),
																].map((list) => {
																	return {
																		label: `${list.name} (${list.isoCode}) +${list.callingCode}`,
																		onClick: () => handleCountrySelection(list),
																	};
																})}
															/>
														</Box>
													</InputAdornment>
												),
											}}
											onBlur={(event) => {
												if (phoneNumber.length < 3 || !!phoneNumberError) {
													return;
												}
												handleParsePhoneNumber();
												parsePhoneNumber();
											}}
											onChange={(evt, error) => {
												handlePhoneNumber(evt, error);
												onPhoneNumParsedSuccess(false);
											}}
										/>
									)}
									{triggerNotificationType ===
										NOTIFICATION_TRIGGER_TYPES.EXTENSION && (
											<>
												{!loadedExtension ? (
													<Skeleton width="100%" height={92} />
												) : (
													<Autocomplete
														label="Extension number"
														getOptionLabel={(option) => {
															return `${option.extensionNumber || ""}${
															option.extensionNumber ? "-" : ""
															}${option.name || ""}`;
														}}
														value={extensionNumber}
														options={extensionList}
														onChange={(evt, value) => {
															extensionNumberOnChange(value)
														}}
														renderInput={(params) => (
															<TextField
																size="small"
																placeholder="Type or select extension from the dropdown"
																{...params}
																label="Extension number"
															/>
														)}
													/>
												)}
											</>
										// <TextField
										// 	size="small"
										// 	type="number"
										// 	sx={{
										// 		...style.extensionInput,
										// 		marginTop: "12px",
										// 		"&  .MuiInputBase-root": {
										// 			backgroundColor: "#ffffff",
										// 			borderRadius: "5px",
										// 		},
										// 	}}
										// 	label="Enter ext number"
										// 	placeholder="12345678"
										// 	onChange={(event, error) =>
										// 		extensionNumberOnChange(event, error)
										// 	}
										// 	// validations={{
										// 	//   [VALIDATIONS.REQUIRED]: true,
										// 	//   [VALIDATIONS.MAX_LENGTH]: 8,
										// 	// }}
										// 	value={extensionNumber}
										// />
									)}
									{triggerNotificationType ===
										NOTIFICATION_TRIGGER_TYPES.VOICEMAIL_NOTIFICATION && (
											<>
												{!loadedExtension ? (
													<Skeleton width="100%" height={92} />
												): (
													<Autocomplete
														label="Voicemail notification"
														getOptionLabel={(option) => {
															return `${option.name || ""}${option.extensionNumber ? ` (Ext. ${option.extensionNumber})` : ""}`
														}}
														value={voicemail_extensions}
														options={extensionList}
														onChange={(event, value) => {
															handleVoicemailExtension(event, value);
														}}
														renderInput={(params) => (
															<TextField
																size="small"
																placeholder="Type or select user(s) from the dropdown"
																{...params}
																label="Extension of Mailbox"
															/>
														)}
													/>
												)}
											</>
									)}
								</Box>
							)}
							{currentSection === 1 && (
								<Box className={style.formSectionWrapper}>
									<Typography sx={{ color: "grey", mb: 3 }} variant="h5">
										Call Direction for Notification Trigger
									</Typography>
									<Typography
										// className="color-grey secondary-font"

										sx={{ color: "grey" }}
										variant="subtitle2"
									>
										Selecting a new call direction will overwrite the existing
										direction.
									</Typography>
									{triggerNotificationType ===
										NOTIFICATION_TRIGGER_TYPES.VOICEMAIL_NOTIFICATION && (
										<Alert sx={{ my: 2 }} severity="warning">
											Only inbound direction is allowed for voicemail
											notifications.
										</Alert>
									)}
									<RadioGroup
										sx={{ display: "flex", flexDirection: "row" }}
										aria-label="call direction"
										name="call_direction"
										value={callDirection}
										onChange={(event) => handleCallDirection(event)}
									>
										<FormControlLabel
											value="Inbound"
											disabled={
												triggerNotificationType ===
												NOTIFICATION_TRIGGER_TYPES.VOICEMAIL_NOTIFICATION
											}
											control={<Radio />}
											label={
												<Box
													sx={{
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}
												>
													<Typography sx={{ mr: 2 }} variant="body2">
														Inbound
													</Typography>
													<img
														alt=""
														src={
															callDirection === "Inbound" &&
															triggerNotificationType !==
																NOTIFICATION_TRIGGER_TYPES.VOICEMAIL_NOTIFICATION
																? "/assets/inbound-call.svg"
																: "/assets/inbound-call-grey.svg"
														}
													/>
												</Box>
											}
										/>
										<FormControlLabel
											value="Outbound"
											disabled={
												triggerNotificationType ===
												NOTIFICATION_TRIGGER_TYPES.VOICEMAIL_NOTIFICATION
											}
											control={<Radio />}
											label={
												<Box
													sx={{
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}
												>
													<Typography sx={{ mr: 2 }} variant="body2">
														Outbound
													</Typography>
													<img
														alt=""
														src={
															callDirection === "Outbound"
																? "/assets/outbound-call.svg"
																: "/assets/icons/outbound-call-grey.svg"
														}
													/>
												</Box>
											}
										/>
										<FormControlLabel
											value="Both Directions"
											disabled={
												triggerNotificationType ===
												NOTIFICATION_TRIGGER_TYPES.VOICEMAIL_NOTIFICATION
											}
											control={<Radio />}
											label={
												<Box
													sx={{
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}
												>
													<Typography sx={{ mr: 2 }} variant="body2">
														Both Directions
													</Typography>
													<img
														alt=""
														src={
															callDirection === "Both Directions"
																? "/assets/bothdirections-call.svg"
																: "/assets/bothdirections-call-grey.svg"
														}
													/>
												</Box>
											}
										/>
									</RadioGroup>
								</Box>
							)}
						</Box>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button sx={{ m: 3, color: "#000000DE" }} onClick={handleClose}>
						<Typography variant="body2">Cancel</Typography>
					</Button>
					{currentSection === 1 && (
						<Button sx={{ m: 3, color: "#000000DE" }} onClick={onClickBack}>
							<Typography variant="body2">Back</Typography>
						</Button>
					)}
					<Button
						sx={{ m: 3, backgroundColor: "#0798fa", borderRadius: "5px" }}
						disabled={
							!isSectionComplete(currentSection) || isParsingPhoneNumber || updating
						}
						onClick={onClickNext}
						variant="contained"
						color="secondary"
					>
						<Typography variant="body2">
							{currentSection === 1 ? "Edit Notifications" : "Next"}
						</Typography>
						{(isParsingPhoneNumber || updating) && (
							<CircularProgress
								size={18}
								sx={{
									position: "absolute",
									// top: "320%",
									// left: "180%",
									// marginTop: -12,
									// marginLeft: -12,
								}}
							/>
						)}
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog open={confirming}>
				<DialogTitle>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Typography variant="h6" sx={{ mt: 2 }}>
							Confirm Bulk Edit
						</Typography>
						<IconButton>
							<CloseIcon
								sx={{ color: "grey.600" }}
								fontSize="small"
								onClick={handleClose}
							/>
						</IconButton>
					</Box>
				</DialogTitle>
				<DialogContent sx={{ width: 400 }}>
					<Box>
						<Typography>
							Are you sure you want to bulk edit these settings for the
							notifications you have selected? This action cannot be undone.
						</Typography>
						{updating && (
							<Box sx={{ display: "flex", alignItems: "center", mt: 5 }}>
								<Checkbox
									checked={!confirmEdit}
									onChange={onPreferenceChange}
								/>
								<Typography variant="body1">
									Do not show this message again.
								</Typography>
							</Box>
						)}
					</Box>
				</DialogContent>
				<DialogActions>
					<Button sx={{ color: "rgba(0, 0, 0, 0.87)" }} onClick={handleClose}>
						<Typography variant="body2">Cancel</Typography>
					</Button>
					<Button
						onClick={handleFormSubmit}
						sx={{
							m: 4,
							backgroundColor: "#0798fa",
							borderRadius: "5px",
							color: "white",
						}}
						// color={updating ? 'default' : 'secondary'}
						disabled={updating}
						variant="contained"
						color="secondary"
					>
						{updating && (
							<CircularProgress size={18} sx={{ position: "absolute"}} />
						)}
						<Typography variant="body2">Confirm</Typography>
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default BulkEditView;
